import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import _, { round } from "lodash";
import { Gauge, Bar, Column, Funnel } from "@ant-design/plots";
import { Col, Row, Table } from "antd";

import {
  getTopClosedOpportunity,
  getTopOpenOpportunity,
  getGroupedCountData,
  getSalesTrendData,
} from "../../actionCreator/dashboardActionCreator";
import { getUserInfo } from "../../utils/utils";

const LeadReport = () => {
  const dispatch = useDispatch();

  const userAccountInfo = useSelector(
    (state) => state.CommonReducer.accountInfo
  );
  const closedOpprtunityData = useSelector(
    (state) => state.DashboardReducer.closedOpp
  );
  const openOpprtunityData = useSelector(
    (state) => state.DashboardReducer.openOpp
  );
  const groupedCountData = useSelector(
    (state) => state.DashboardReducer.groupedCountData
  );
  const salesTrendData = useSelector(
    (state) => state.DashboardReducer.salesTrendData
  );
  useEffect(() => {
    if (Object.keys(getUserInfo())?.length) {
      dispatch(getTopClosedOpportunity());
      dispatch(getTopOpenOpportunity());
      dispatch(getGroupedCountData());
      dispatch(getSalesTrendData());
    }
  }, [userAccountInfo, dispatch]);

  let leadConversionValue = 0;
  let opportunityWonValue = 0;
  let leadConversionRate = 0;
  let opportunityWonRatio = 0;
  let lostOpportunity = 0;
  let salesOrderByStatus = [{ typeValue: "", countSum: 0 }];
  let salesTrendWonData = [];
  let salesTrendWonDataByMonth = [];
  const wonStatus = "Closed Won";
  const lostStatus = "Closed Lost";
  const unQualifiedStatus = "Un-Qualified";
  const qualifiedStatus = "Sales Qualified";
  const monthNames = [
    "",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  if (salesTrendData?.dashboardDTOS?.length > 0) {
    salesTrendData?.dashboardDTOS?.forEach((record) => {
      record.month = record?.typeValue ? monthNames[record.typeValue] : "";
      record.opportunitSum =
        record?.opportunitSum && record?.opportunitSum !== "null"
          ? parseFloat(record?.opportunitSum)
          : 0;
      salesTrendWonData.push(record);
    });
    if (salesTrendWonData) {
      salesTrendWonDataByMonth = _.map(
        _.groupBy(salesTrendWonData, "typeValue"),
        (o, month) => {
          return {
            month: month ? monthNames[month] : "",
            opportunitSum: _.sumBy(o, function (record) {
              return record?.statusId === "16" ? record?.opportunitSum : 0;
            }),
          };
        }
      );
    }
  }
  if (groupedCountData?.dashboardDTOS?.length > 0) {
    groupedCountData?.dashboardDTOS?.forEach((record) => {
      record.countSum = record?.countSum ? parseInt(record.countSum) : 0;
      if (record?.typeValue === qualifiedStatus) {
        leadConversionValue += Number(record.countSum);
      }
      record.opportunitSum =
        record.opportunitSum === "null" ? 0 : record.opportunitSum;
      if (record?.typeValue === wonStatus) {
        opportunityWonValue += Number(record.countSum);
      }
      if (
        record?.typeValue === unQualifiedStatus ||
        record?.typeValue === lostStatus
      ) {
        lostOpportunity += Number(record.opportunitSum);
      }
    });
    let rawData = groupedCountData?.dashboardDTOS;
    salesOrderByStatus = _.orderBy(rawData, "countSum", "desc");
  }
  if (groupedCountData?.leadGenareatedCount > 0) {
    leadConversionRate = round(
      (leadConversionValue / groupedCountData?.leadGenareatedCount) * 100,
      2
    );
    opportunityWonRatio = round(
      (opportunityWonValue / groupedCountData?.leadGenareatedCount) * 100,
      2
    );
  }
  const columns = [
    {
      title: "Opportunity with Account name",
      dataIndex: "fullname",
      key: "fullname",
    },
    {
      title: "Amount",
      dataIndex: "oppurtunityAmount",
      key: "oppurtunityAmount",
    },
    {
      title: "Owner & Closing Date",
      dataIndex: "createdBy",
      key: "createdBy",
    },
  ];

  const config = {
    data: salesOrderByStatus,
    xField: "typeValue",
    yField: "countSum",
    label: {
      text: (d) => `${d.stage}\n${d.number}`,
    },
    showFacetTitle: false,
    yAxis: {
      visible: false,
      label: {
        formatter: (v) => parseInt(v),
      },
    },
    meta: {
      value: {
        min: 0,
        max: 100,
      },
    },
    conversionTag: "",
    widthRatio: 0.8,
  };

  let totalOpportunity = groupedCountData?.totalOpportunity; //50;
  let totalValueRate = groupedCountData?.totalValueRate; //100;
  let salesTarget = 0;
  let salesPerc = 0;
  let meterPerc = 0.1;
  if (totalValueRate > 0) {
    salesTarget = totalOpportunity / totalValueRate;
    salesPerc = round(totalOpportunity / totalValueRate, 2);
    meterPerc = salesPerc / 100;
  }
  if (salesPerc > 100) {
    salesPerc = 100;
  }
  if (meterPerc > 100) {
    meterPerc = 100;
  }

  const chart2 = {
    percent: meterPerc,
    radius: 0.75,
    innerRadius: 0.75,
    range: {
      ticks: [salesTarget / 100, 1],
      color: ["#39B8FF", "#C0EDF3"],
    },
    statistic: {
      content: {
        offsetY: 36,
        offsetX: 6,
        style: {
          fontSize: "24px",
          color: "#4B535E",
        },
        formatter: () => salesPerc + "%",
      },
    },
  };

  const chart3 = {
    data: salesTrendWonDataByMonth,
    xField: "month",
    yField: "opportunitSum",
    columnWidthRatio: 0.6,
    label: {
      position: "middle",
      style: {
        fill: "#fff",
        opacity: 0.6,
      },
      content: (item) => (item.opportunitSum ? `${item.opportunitSum}` : ""),
    },
    tooltip: {
      formatter: (datum) => ({
        name: "Opportunity",
        value: `${datum.opportunitSum}`,
      }),
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
      title: {
        text: "Month",
      },
    },
    yAxis: {
      title: {
        text: "Opportunity Amount",
      },
    },
    meta: {
      month: {
        alias: "Month",
      },
      opportunitSum: {
        alias: "Opportunity Amount",
      },
    },
    interactions: [
      {
        type: "active-region",
      },
    ],
  };

  const chart4 = {
    data: openOpprtunityData,
    xField: "oppurtunityAmount",
    yField: "fullname",
    seriesField: "fullname",
    legend: true,
    meta: {
      fullname: {
        alias: "Category",
      },
      oppurtunityAmount: {
        alias: "Amount",
      },
    },
    minBarWidth: 20,
    maxBarWidth: 20,
  };

  const closedOpportunities = {
    data: closedOpprtunityData
      ?.map((d) => ({
        name: d?.firstname + " " + d?.lastname,
        value: d?.oppurtunityAmount || 0,
      }))
      .sort((a, b) => b.value - a.value),
    xField: "value",
    yField: "name",
    seriesField: "name",
    colorField: "name",
    legend: false,
    barWidthRatio: 0.6,
    tooltip: {
      formatter: (datum) => ({
        name: datum.name,
        value: `${datum.value}`,
      }),
    },
    label: {
      position: "middle",
      style: {
        fill: "#fff",
      },
      content: (item) => item.value.toLocaleString(),
    },
    interactions: [{ type: "active-region" }],
    layout: "horizontal",
  };

  return (
    <>
      <div id="filter" className="row mx-0 mt-4 pt-4">
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                Lead Generated
              </div>
              <div className="row mx-0 no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    {groupedCountData?.leadGenareatedCount}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="las la-filter fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-success shadow h-100 py-2">
            <div className="card-body">
              <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                Lead Conversion Rate
              </div>
              <div className="row mx-0 no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    {leadConversionRate}%
                  </div>
                </div>
                <div className="col-auto">
                  <i className="las la-funnel-dollar fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-info shadow h-100 py-2">
            <div className="card-body">
              <div className="text-xs font-weight-bold text-leftinfo text-uppercase mb-1">
                Opportunity Won Ratio
              </div>
              <div className="row mx-0 no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="row mx-0 no-gutters align-items-center">
                    <div className="col-auto">
                      <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">
                        {opportunityWonRatio}
                      </div>
                    </div>
                    <div className="col">
                      <div className="progress progress-sm mr-2">
                        <div
                          className="progress-bar bg-info"
                          role="progressbar"
                          aria-valuenow="50"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <i className="las la-percent fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-warning shadow h-100 py-2">
            <div className="card-body">
              <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                Open Opportunities
              </div>
              <div className="row mx-0 no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    ₹{groupedCountData?.leadOpenOpportunity}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="las la-comments fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-danger shadow h-100 py-2">
            <div className="card-body">
              <div className="text-xs font-weight-bold text-danger text-uppercase mb-1">
                Pipeline Contribution
              </div>
              <div className="row mx-0 no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    ₹{groupedCountData?.totalOpportunity}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="las la-hand-holding-usd fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-dark shadow h-100 py-2">
            <div className="card-body">
              <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                Lost Opportunities
              </div>
              <div className="row mx-0 no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    ₹{lostOpportunity}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="lab la-creative-commons-nc fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mx-0">
        <div className="col-xl-8 col-lg-7">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-uppercase text-gray-800">
                Sales Pipeline Report
              </h6>
            </div>
            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 250 }}>
                      <Funnel {...config} />
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-uppercase text-gray-800">
                Closed Sales (Actual VS Target)
              </h6>
            </div>
            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 220 }}>
                      <Gauge {...chart2} />
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mx-0">
        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-uppercase text-gray-800">
                Sales Trend
              </h6>
            </div>
            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 220 }}>
                      <Column {...chart3} />
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-gray-800 text-uppercase">
                Top 5 Open Opportunities
              </h6>
            </div>

            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 220 }}>
                      <Bar {...chart4} />
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-8 col-lg-7">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-gray-800 text-uppercase">
                Top 5 Closed Opportunities
              </h6>
            </div>
            <Row>
              <Col xs={24} md={12}>
                <div className="card-body">
                  <Bar {...closedOpportunities} />
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div className="card-body">
                  <div className="chart-area">
                    <Table
                      pagination={{ position: ["none"] }}
                      dataSource={closedOpprtunityData}
                      columns={columns}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};
export default LeadReport;
